import { render, staticRenderFns } from "./PolvoButton.vue?vue&type=template&id=470fdac6&scoped=true&lang=html&"
import script from "./PolvoButton.vue?vue&type=script&lang=js&"
export * from "./PolvoButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "470fdac6",
  null
  
)

export default component.exports